import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway'
import SMCLabel from '../../../../components/Simple/SMCLabel';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import Separator from '../../../../components/Simple/Sepperator';
import SetUserModal from '../../../PopupPages/SetUserModal';
import {useBoolean} from '../../../../utils/hooks';
import {useTranslation} from 'react-i18next';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import SMCButton from '../../../../components/Simple/SMCButton';
import {UserGetSchema} from '../../../../api/DBSchema/User';
import Api from '../../../../api/SMPFetchHelper';
import {ObjectTypes} from '../../../../api/consts';

function GatewayOwner({
    userObject,
    removeGatewayOwner,
    setGatewayData,
    setUserObject,
    gatewayObject
}) {
    const { t } = useTranslation();
    
    const [isOwnerWindowOpen, openOwnerWindow, closeOwnerWindow] = useBoolean(false);
    const hasOwner = gatewayObject[GatewayGetSchema.ownerId] && userObject.id;

    const handleSetOwner = useCallback(userList => {
        const ownerId = userList[0];
        Api.fetchSingleObject(ObjectTypes.USER, ownerId)
            .then(resp => {
                const userData = resp.data.data.user;
                setGatewayData(GatewayGetSchema.ownerId, userData[UserGetSchema.id]);
                setUserObject(userData);
                closeOwnerWindow();
            })
            .catch(e => {
                console.log(e.message);
                alert(t('SMP.GATEWAYS.CHANGE_PLAN.ERROR.FETCHING_SELECTED'))
            })
    }, [setGatewayData, setUserObject, closeOwnerWindow, t]);

    if (hasOwner) {
        return (
            <EditorLayout>
                <SMCTextInput readOnly value={userObject.id} label={t('SMC_USER_UID')} />
                <SMCTextInput readOnly value={userObject.general.firstName} label={t('SMC_USER_FNAME')} />
                <SMCTextInput readOnly value={userObject.general.lastName} label={t('SMC_USER_LNAME')} />
                <SMCTextInput readOnly value={userObject.contact.organization} label={t('SMC_USER_ORGANIZATION')} />
                <SMCTextInput readOnly value={userObject.general.email} label={t('SMC_USER_EMAIL')} />
                <Separator />
                <SMCButton onClick={removeGatewayOwner}>Remove owner</SMCButton>
            </EditorLayout>
        )
    } else {
        return (
            <EditorLayout>
                <SMCLabel bold>{t('SMP.GATEWAYS.PAGE.OWNER.LINE1')}</SMCLabel>
                <div>
                    <SMCButton onClick={openOwnerWindow}>Set owner</SMCButton>
                </div>
                <SetUserModal
                    isOpen={isOwnerWindowOpen}
                    onRequestClose={closeOwnerWindow}
                    onSuccess={handleSetOwner}
                    isOwnerModal={true}
                />
            </EditorLayout>
        );
    }
}

export default GatewayOwner;